import { render, staticRenderFns } from "./form-sum.vue?vue&type=template&id=6464e8f7&scoped=true"
import script from "./form-sum.vue?vue&type=script&lang=js"
export * from "./form-sum.vue?vue&type=script&lang=js"
import style0 from "./form-sum.vue?vue&type=style&index=0&id=6464e8f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6464e8f7",
  null
  
)

export default component.exports